import { findProductByValue } from '../../../common';
import { downloadExcel } from '../../../../utils/excel';

/** Inventory rows for the warehouse table. */
export function buildInventoryRows(inventory) {
    return inventory?.map((product, idx) => ({
        key: `${product?.productId}-${idx}`,
        // Resolve tolerant of case/whitespace drift between inventory codes and catalog values,
        // otherwise every row falls back to "Producto desconocido".
        name: findProductByValue(product?.productId)?.name || 'Producto desconocido',
        productId: product?.productId,
        quantity: product?.quantity ?? 0,
        available: product?.isAvailable,
        isEmergency: product?.isEmergency || false,
        // Optional per-product capture some companies add (e.g. 'YYYY-MM-DD'); null when absent.
        expirationDate: product?.expirationDate ?? null
    }));
}

/** Summary counts shown above the table. */
export function summarizeInventory(inventoryRows) {
    const totalItems = inventoryRows?.length || 0;
    const availableItems = inventoryRows?.filter((i) => i.available)?.length || 0;
    const emergencyItems = inventoryRows?.filter((i) => i.isEmergency)?.length || 0;
    return { totalItems, availableItems, emergencyItems };
}

/** Exports the inventory exactly as before. */
export function downloadInventory(inventoryRows) {
    const columns = ['Producto', 'Código', 'Cantidad (Bultos)', 'Disponibilidad', 'Estado'];
    const data = inventoryRows.map((row) => ({
        Producto: row.name,
        Código: row.productId,
        'Cantidad (Bultos)': row.quantity,
        Disponibilidad: row.available ? 'Disponible' : 'No Disponible',
        Estado: row.isEmergency ? 'Emergencia' : 'Normal'
    }));
    downloadExcel(columns, data, 'Inventario');
}
